module.exports = "pegasus/assets/email1-column-10.png";